import React from 'react'
import { GoHeart } from "react-icons/go"
import { FiUsers } from "react-icons/fi"
import './menu.css'
import useAppContext from '../../hook/useAppContext'

const Menu = () => {

      const {user, showFriend, setShowFriend, showRelation, setShowRelation} = useAppContext()
      const {friends} = user 

      const friends_amount = friends.code ? 0 : friends.length 

      const openRelation = () => {
            setShowRelation(!showRelation)
      }

      const openFriends = () => {
            setShowFriend(!showFriend)
      }

      return (
            <div className="menu_content flex">
                  <div className="menu_content__btns flex">
                        <button className="menu_btn flex" onClick={() => openRelation()}><GoHeart /></button>
                        <button className="menu_btn flex" onClick={() => openFriends()}><FiUsers /><span>{friends_amount}</span></button>
                  </div>
                  <div className="menu_content__dots"></div>
            </div>
      )
}

export default Menu
